export const orderByLikeableCount = (a, b) => b.likeableCount - a.likeableCount;
